const fetchGeneros = async(filtro = 'movie') => {
    const tipo = filtro === 'movie' ? 'movie' : 'tv';

    const url = `https://api.themoviedb.org/3/genre/${tipo}/list?api_key=71215a991e35e69723fc495d6d25c8fc&language=es-ARG`;

    try {
        const respuesta = await fetch(url);
        const datos = await respuesta.json();
        return datos.genres;
    } catch (e) {
      console.log(e);     
}
};

export default fetchGeneros;